document.addEventListener('DOMContentLoaded', function() {
  const mobileSlider = document.querySelector('.mobile-only-slider');
  
  function initMobileSlider() {
    if (window.matchMedia('(max-width: 900px)').matches) {
      $(mobileSlider).slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false
      });
    } else {
      if ($(mobileSlider).hasClass('slick-initialized')) {
        $(mobileSlider).slick('unslick');
      }
    }
  }

  // Initialisierung
  if (mobileSlider) {
    initMobileSlider();
    window.addEventListener('resize', initMobileSlider);
  }
});